import React from 'react';
import FallbackIcon from './assets/fallback_grocery.svg.js';
import { CartCardContainer, CartCardImage, CartCardInner, CartCardInnerTop, CartCardInfo, MarkingsContainer, CartCardTitle, CartCardDelete, CartCardPriceContainer, PriceContainer, QuantitySelectorContainer } from './CartCard.styles.js';
import { Icons } from '@citygross/icons';
import { CgButton } from '../CgButton/CgButton.js';
import { EButtonVariant } from '../CgButton/CgButton.types.js';

var CartCard = function CartCard(_a) {
  var description = _a.description,
      image = _a.image,
      markings = _a.markings,
      onDelete = _a.onDelete,
      price = _a.price,
      quantitySelector = _a.quantitySelector,
      secondaryDescription = _a.secondaryDescription,
      showDelete = _a.showDelete,
      title = _a.title,
      _b = _a.titleLineClamp,
      titleLineClamp = _b === void 0 ? 1 : _b,
      titleLink = _a.titleLink;
  return React.createElement(CartCardContainer, null, React.createElement(CartCardImage, {
    src: image || FallbackIcon
  }), React.createElement(CartCardInner, null, React.createElement(CartCardInnerTop, null, React.createElement(CartCardInfo, null, markings && React.createElement(MarkingsContainer, null, markings), titleLink || title && React.createElement(CartCardTitle, {
    titleLineClamp: titleLineClamp
  }, title), description && description), showDelete && React.createElement(CartCardDelete, null, React.createElement(CgButton, {
    onClick: onDelete,
    variant: EButtonVariant.secondary
  }, React.createElement(Icons.Trash, {
    width: 16,
    height: 16
  })))), secondaryDescription && secondaryDescription, React.createElement(CartCardPriceContainer, null, React.createElement(PriceContainer, null, price), !showDelete && React.createElement(QuantitySelectorContainer, null, quantitySelector))));
};

export { CartCard };